<template>
  <div class="app-email-i">
    <div class="ae-content-w scrollable">
      <div class="">
        <div class="actions-left">
          <div class="plan-body">
            <div class="row m-b">
              <div class="col-sm-6 b-r b-b">
                <div class="el-tablo centered padded-v">
                  <div class="value">{{pagination.total}}</div>
                  <div class="label">Products</div>
                </div>
              </div>
              <div class="col-sm-6 b-b">
                <div class="el-tablo centered padded-v">
                  <div class="value">{{age.average_age || '--'}} Days</div>
                  <div class="label">Average Age</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="actions-right"></div>
      </div>
      <Loader v-if="isLoading" />
      <div class="p-3 row" v-else>
        <table class="table table-padded">
          <thead>
            <tr>
              <th>Product</th>
              <th>Inbound</th>
              <th>Location</th>
              <th>Description</th>
              <th class="text-center">Category</th>
              <th>Age</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in pagination.data">
              <td class="nowrap">
                <span>{{product.item_identifier}}</span>
                <br />
                <span>{{product.item_parent_identifier}}</span>
                <br />
              </td>
              <td>
                <span>{{formatDate(product.inbound_at).date}}</span>
                <span class="smaller lighter">{{formatDate(product.inbound_at).time}}</span>
              </td>
              <td>
                <span>{{product.location}}</span>
              </td>
              <td class="cell-with-media">
                <clazy-load
                  :src="formatPreview(product.preview)"
                  class="incoming-image"
                  style="height: 40px;"
                >
                  <img
                    :src="formatPreview(product.preview)"
                    @error="formatPreview()"
                    style="height: 40px;"
                  />
                  <div class="preloader" slot="placeholder">
                    <img :src="product.preview" style="height: 40px;" />
                  </div>
                </clazy-load>
                <span>{{product.brand}} - {{product.color}} - {{product.size}}</span>
              </td>
              <td class="text-center">
                {{product.category_name}}
              </td>
              <td class="text-center">
                {{product.age}} Days
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <div class="table-responsive" >
                    <table class="table table-striped table-lightborder table-striped">
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Inbound At</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in pagination.data">
                                <td>
                                    <div class="element-box-tp">
                                        <div class="profile-tile">
                                            <a class="profile-tile-box">
                                                <div class="pt-avatar-w">
                                                    <clazy-load :src="formatPreview(product.preview)" class=" incoming-image">
                                                        <img :src="formatPreview(product.preview)" @error="formatPreview()">
                                                        <div class="preloader" slot="placeholder">
                                                            <img :src="product.preview" >
                                                        </div>
                                                    </clazy-load>
                                                </div>
                                            </a>
                                            <div class="profile-tile-meta">
                                                <ul>
                                                    <router-link tag="li" :to="`/productdesk/product/${product.id_product}`" class="clickable-link">
                                                        <strong>{{product.item_identifier}}</strong>
                                                    </router-link>

                                                    <li>
                                                        {{product.item_parent_identifier}}
                                                    </li>
                                                    <li>
                                                        {{product.category_name}}
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>{{product.inbound_at}}</td>
                                <td>{{product.location}}</td>
                            </tr>
                        </tbody>
                    </table>
        </div>-->
        <Pagination
          v-if="pagination.last_page > 1 "
          :pagination="pagination"
          @paginate="getInventory()"
          :offset="5"
        ></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CommonFunctions from '@/mixins/common-functions.js'
import Pagination from '@/components/common/Pagination'

import Loader from '@/components/common/Loader'

export default {
  mixins: [CommonFunctions],
  components: { Loader, Pagination },
  props: ['selectedChannel', 'updateKey'],
  data () {
    return {
      isLoading: true,
      pagination: {
        current_page: 1
      }
    }
  },

  methods: {
    getInventory: function () {
      var self = this
      const url = '/productdesk/inventory?page=' + this.pagination.current_page

      self.isLoading = true

      let data = {
        id_channel: self.selectedChannel,
        type: 'checkin'
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.pagination = response.data.products
          self.age = response.data.average_age
          self.isLoading = false
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: 'Error fetching inventory',
            show: true
          })
          self.isLoading = false
        })
    },
    formatDate (inbound_at) {
      if (inbound_at == null) return null
      var date = this.moment(inbound_at).format('Do MMM, YYYY')
      var time = this.moment(inbound_at).format('hh:mm a')
      return {
        date: date,
        time: time
      }
    }
  },
  watch: {
    updateKey () {
      this.getInventory()
    },
    selectedChannel () {
      this.getInventory()
    }
  }
}
</script>

<style scoped>
.aec-full-message-w .message-content {
  padding: 0px;
}
.property-single .property-info-w {
  padding: 0px;
}
.property-single .property-info-w .property-info-main {
  padding: 10px;
}
.property-single .property-info-w .property-section .property-section-body {
  padding: 10px 0px;
}
.ae-content {
  padding: 0px;
}
.profile-tile {
  flex-direction: row;
  justify-content: left;
  padding-left: 10px;
}
.profile-tile-box {
  margin: 5px;
}
.profile-tile .pt-avatar-w {
  border-radius: 0px;
}
.inline-block {
  display: inline-block;
}

.property-side-features .feature {
  padding: 5px 10px;
}
.hidden {
  display: none;
}
td {
  white-space: nowrap;
}
td.wrap {
  white-space: normal;
}
td.center {
  text-align: center;
}
.clickable {
  color: blue;
  cursor: pointer;
}
.element-box {
  display: flex;
  flex: 1;
  overflow-x: scroll;
  overflow-y: scroll;
}
.product-flags {
  margin-right: 5px;
}
.Yes-Circle::before {
  content: "\f058";
  color: #75da62 !important;
}

.No-Circle::before {
  content: "\f057";
  color: #ed1c24 !important;
}

.Skipped-Circle::before {
  content: "\f05e";
}

.Skipped::before {
  content: "\f05e";
}

.Yes-text {
  color: #75da62 !important;
  font-weight: 500;
}
.Yes::before {
  content: "\f00c";
  color: #75da62 !important;
}
.No-text {
  color: #ed1c24 !important;
  font-weight: 500;
}
.No::before {
  content: "\f00d";
  color: #ed1c24 !important;
}
.NA::before {
  content: "\f068";
}
.Pending-text {
  color: #ffa000 !important;
  font-weight: 500;
}
.Pending::before {
  content: "\f12a";
  color: #ffa000 !important;
}
.Styling::before {
  content: "\f0d1";
  color: #000 !important;
}
.Comment::before {
  content: "\f075";
  color: #000 !important;
}
.ForceComplete::before {
  content: "\f560";
  color: #000 !important;
}
.profile-tile .pt-avatar-w {
  border-radius: 0px;
}
.profile-tile .profile-tile-box {
  padding: 0.5rem;
  width: 80px;
}
.profile-tile .profile-tile-meta ul {
  font-size: 13px;
}
.profile-tile .profile-tile-meta {
  padding-left: 10px;
}
.profile-tile .profile-tile-meta ul strong {
  margin-left: 0px;
}
.profile-tile {
  border-bottom: 0px;
  padding-bottom: 0rem;
  margin-bottom: 0rem;
}
.profile-tile .profile-tile-meta ul .clickable-link strong {
  color: #047bf8 !important;
  cursor: pointer;
}
</style>
